.main-product-tabs {
  display: flex;
  margin-bottom: 20px;
  gap: 18px;
}

@media screen and (max-width: 979px) {
  .main-product-tabs {
    gap: 8px;
  }
}

.main-product-tab {
  position: relative;
  display: flex;
  width: 50%;
  justify-content: center;
  align-items: center;
  height: 24px;
  padding-bottom: 8px;
  cursor: pointer;
}

.main-product-tab input[type=radio] {
  width: 100%;
  display: none;
}

.main-product-tab::after {
  content: "";
  position: absolute;
  bottom: -0.5px;
  width: 100%;
  height: 1px;
  background-color: #0f0f0f;
}

.main-product-tab.checked {
  font-weight: bold;
}

.main-product-tab.checked::after {
  height: 5px;
  bottom: -2.5px;
  background-color: var(--qds-theme-signature-color-default);
}

@media screen and (max-width: 979px) {
  .main-product-tab.checked::after {
    bottom: -1.5px;
    height: 3px;
  }
}

.main-product-tab.checked .main-product-tab-label {
  font-weight: bold;
}

.main-product-tab-label {
  cursor: inherit;
  font-size: 1.125rem;
  line-height: 1.5rem;
}

@media screen and (max-width: 979px) {
  .main-product-tab-label {
    padding: 0;
    font-size: 1rem;
  }
}

.main-product-tab-content {
  position: relative;
  display: flex;
  align-items: center;
}

.main-product-tab-badge {
  position: absolute;
  height: 18px;
  padding: 0 8px;
  background-color: #b5e7d1;
  color: var(--qds-theme-signature-color-pressed);
  border-radius: 4px;
  line-height: 1.125rem;
  font-size: 0.625rem;
  font-weight: bold;
  text-align: center;
  word-break: normal;
}

:host(:not([dir="rtl"])) .main-product-tab-badge {
  right: 100%;
  margin-right: 8px;
}

:host([dir="rtl"]) .main-product-tab-badge {
  left: 100%;
  margin-left: 8px;
}

@media screen and (max-width: 979px) {
  .main-product-tab-badge {
    position: relative;
  }

  :host(:not([dir="rtl"])) .main-product-tab-badge {
    margin-right: 8px;
    right: unset;
  }

  :host([dir="rtl"]) .main-product-tab-badge {
    margin-left: 8px;
    left: unset;
  }
}

.main-product-tab-skeleton {
  width: 100%;
  height: 32px;
  background-color: var(--qds-theme-panel-background);
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}

.main-product-tab-skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  animation: shimmer 2s infinite;
}

:host(:not([dir="rtl"])) .main-product-tab-skeleton::after {
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
}

:host([dir="rtl"]) .main-product-tab-skeleton::after {
  transform: translateX(100%);
  background-image: linear-gradient(-90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

.pes-main-area {
  display: block;
  margin-bottom: 24px;
  box-sizing: border-box;
}

.pes-main-area *,
.pes-main-area *::before,
.pes-main-area *::after {
  box-sizing: inherit;
}

.pes-main-area .area__subsection .main-area__info {
  margin: 0;
}

.pes-main-area .main-area__quick-actions {
  display: none;
}

@media screen and (min-width: 980px) {
  .pes-main-area .main-area__quick-actions {
    display: block;
  }
}

.pes-main-area .co2-message {
  display: flex;
  gap: 10px;
  font-weight: bold;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e7e6e6;
}

.pes-main-area .co2-message__icon {
  flex-shrink: 0;
  font-size: 1.375rem;
}

.pes-main-area .co2-message__label {
  font-size: 1.125rem;
}

@media screen and (max-width: 979px) {
  .pes-main-area .co2-message__label {
    font-size: 1rem;
  }
}

.pes-main-area .co2-message__label sub {
  vertical-align: sub;
  font-size: 0.75rem;
}

.pes-main-area .pes-tags {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

@media screen and (max-width: 719px) {
  .pes-main-area .pes-tags {
    flex-direction: column;
  }
}

.area__subsection > .subsection__item {
  margin: 24px 0;
  display: block;
}

.area__subsection > .subsection__item {
  border-top: 1px solid #e7e6e6;
  padding-top: 24px;
}

.area__subsection > .subsection__item ~ .subsection__item {
  border-top: none;
  padding-top: 0;
}

.main-area-tabs-empty-container {
  display: block;
  width: 100%;
  height: 52px;
}

.pes-b2c__redirection {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

@media screen and (min-width: 980px) {
  .pes-b2c__redirection {
    flex-direction: row;
  }
}

.pes-b2c__redirection-link, .pes-b2c__redirection-label {
  display: inline-flex;
  gap: 8px;
}